module.exports = __webpack_public_path__ + "static/img/20-1016-cover.3475124.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/20-1016-cover.jpeg
// module id = khZe
// module chunks = 0